import { Box, List, Title } from '@nimbus-ds/components';
import { GiftBoxIcon } from '@nimbus-ds/icons';
import { CalloutCard } from '@nimbus-ds/patterns';
import { useTranslationDashboard } from 'domains/Dashboard/hooks';
import './BoldProjectAffiliateDiscountAlert.scss';

export function BoldProjectAffiliateDiscountAlert() {
  const t = useTranslationDashboard('trialMessages.bold');

  return (
    <div className="stratus--bold-project-alert">
      <CalloutCard
        appearance="neutral"
        icon={GiftBoxIcon}
        title=""
        subtitle=""
        link={
          <Box display="flex" flexDirection="column" gap="2">
            <Title as="h6">{t('title')}</Title>
            <List as="ul">
              <List.Item>{t('one')}</List.Item>
              <List.Item>{t('two')}</List.Item>
              <List.Item>{t('three')}</List.Item>
            </List>
          </Box>
        }
      />
    </div>
  );
}
